import { ArrowRight } from "lucide-react";
import { BUSINESS, SERVICES } from "../data/site";
import { scrollToId } from "../lib/scroll";
import { Reveal } from "./Reveal";

export const Services = () => (
  <section id="services" data-testid="services-section" className="bg-[#f6f7f9] py-20 sm:py-28">
    <div className="mx-auto max-w-[1240px] px-5 sm:px-8">
      <Reveal>
        <h2 className="text-4xl font-black uppercase tracking-[-0.02em] text-[#161e2b] sm:text-5xl lg:text-6xl">
          SERVICES
        </h2>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-[#5c6675] md:text-lg">
          From precise skin fades to beard sculpting and kids cuts — every
          service is tailored to your look. Choose your barber to view
          availability, services, and pricing.
        </p>
      </Reveal>

      <Reveal delay={0.1} className="mt-14">
        <div
          data-testid="services-grid"
          className="grid grid-cols-1 gap-px overflow-hidden rounded-xl bg-[#e4e7ee] ring-1 ring-[#e4e7ee] sm:grid-cols-2 lg:grid-cols-4"
        >
          {SERVICES.map((service) => (
            <div
              key={service.num}
              data-testid={`service-card-${service.num}`}
              className="group bg-[#f6f7f9] p-7 transition-colors duration-300 hover:bg-white"
            >
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-lg bg-[#111a2c] text-sm font-bold text-white transition-colors duration-300 group-hover:bg-[#4a9bdc]">
                {service.num}
              </span>
              <h3 className="mt-6 text-lg font-extrabold tracking-tight text-[#161e2b]">
                {service.title}
              </h3>
              <p className="mt-2.5 text-sm leading-relaxed text-[#5c6675]">{service.desc}</p>
            </div>
          ))}
        </div>
      </Reveal>

      <Reveal delay={0.15} className="mt-12 text-center">
        <button
          data-testid="services-choose-barber-button"
          onClick={() => scrollToId("barbers")}
          className="group inline-flex items-center gap-2.5 rounded-lg bg-[#4a9bdc] px-9 py-4 text-sm font-bold tracking-[0.08em] text-white transition-colors duration-300 hover:bg-[#5aaae8]"
        >
          CHOOSE YOUR BARBER
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </button>
        <p className="mt-8 text-sm text-[#5c6675]">
          Don&apos;t see what you need? Give us a call at{" "}
          <a
            data-testid="services-phone-link"
            href={`tel:${BUSINESS.phoneTel}`}
            className="font-semibold text-[#4a9bdc] underline-offset-4 hover:underline"
          >
            {BUSINESS.phoneDisplay}
          </a>{" "}
          and we&apos;ll take care of you.
        </p>
      </Reveal>
    </div>
  </section>
);
